import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { Language } from '@api/models';
import { LanguageService } from '../../services/language/language.service';
import { UrlService } from '../../services/url.service';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DeviceService } from '../../services/device-detector/device.service';

@Component({
  selector: 'lang-selector',
  templateUrl: './lang-selector.component.html',
  styleUrls: ['./lang-selector.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LangSelectorComponent implements OnInit {
  protected readonly languageService = inject(LanguageService);
  private urlService = inject(UrlService);
  private router = inject(Router);
  private analyticsService = inject(GoogleAnalyticsService);
  private destroyRef = inject(DestroyRef);
  private deviceService = inject(DeviceService);

  readonly isInSidebar = input<boolean>(false);
  readonly languages = signal<{ code: Language; link: string; label: string }[]>([]);

  private readonly preferLangParam = 'prefer_lang';

  ngOnInit(): void {
    this.handlePreferLangParam();

    this.setLanguages();
    this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe({
        next: event => {
          if (event instanceof NavigationEnd) {
            this.setLanguages();
          }
        }
      });
  }

  private handlePreferLangParam(): void {
    if (!this.deviceService.isPlatformBrowser()) {
      return;
    }
    this.urlService.deleteQueryParams([this.preferLangParam], 'replace');

    this.analyticsService.changeLang(this.languageService.getCurrentLang());
  }

  private setLanguages(): void {
    const buildLink = (lang: Language) => {
      const link = this.urlService.buildCurrentPathWithLang(lang, true);
      const [path, query = ''] = link.split('?');
      const params = new URLSearchParams(query);
      params.delete(this.preferLangParam);
      params.set(this.preferLangParam, 'true');
      return `${path}?${params.toString()}`;
    };

    this.languages.set([
      {
        code: Language.UK,
        link: buildLink(Language.UK),
        label: 'UA'
      },
      {
        code: Language.RU,
        link: buildLink(Language.RU),
        label: 'RU'
      },
    ]);
  }
}
